import React, { useEffect } from 'react'
import { connect } from 'dva'
import PropTypes from 'prop-types'
import styles from './ZoomLevel.module.scss'

function ZoomLevel(props) {
  useEffect(() => {
    props.view.watch('zoom', function (zoomLevel) {
      if (zoomLevel > 0) {
        props.dispatch({
          type: 'map/setZoomLevel',
          payload: zoomLevel.toFixed(2)
        })
      }
    })
  }, [props.view])

  return props.showZoomLevel ? (
    <div className={['esri-widget', 'esri-component', styles.container].join(' ')}>
      <div>{props.zoomLevel}</div>
    </div>
  ) : null
}

ZoomLevel.propTypes = {
  showZoomLevel: PropTypes.bool,
  view: PropTypes.any,
  zoomLevel: PropTypes.string
}

export default connect(model => ({
  zoomLevel: model.map.zoomLevel
}))(ZoomLevel)
